import s from './Input.module.css';

export default function Input({ label, help, error, id, className = '', ...rest }) {
  const inputId = id || (label ? `inp-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
  return (
    <label className={s.field} htmlFor={inputId}>
      {label && <span className={s.label}>{label}</span>}
      <input
        id={inputId}
        className={`${s.input} ${error ? s.error : ''} ${className}`.trim()}
        {...rest}
      />
      {error && <span className={`${s.help} ${s.errorText}`}>{error}</span>}
      {!error && help && <span className={s.help}>{help}</span>}
    </label>
  );
}
